import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/globals.css';
import type { AppProps } from 'next/app';
import Head from "next/head";
import { useRouter } from "next/router";
import { Provider as ReduxProvider } from "react-redux"; 

// Import the Shopify App Bridge Provider
import { Provider as AppBridgeProvider } from "@shopify/app-bridge-react";

import { AuthProvider } from "../context/AuthContext";
import store from "../store/store";

export default function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();

  // Extract the 'host' parameter safely from either the query or the URL
  const host =
    (router.query.host as string) ||
    (typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("host")
      : null);

  // Your main app component tree
  const AppContent = (
    <ReduxProvider store={store}>
      <AuthProvider>
        <Component {...pageProps} />
      </AuthProvider>
    </ReduxProvider>
  );

  return (
    <>
      <Head>
         <link href="/StrikeTru_favicon.ico" rel="icon" sizes="32x32" />
      </Head>

      {/* If 'host' exists, wrap the app in Shopify's App Bridge */}
      {host ? (
        <AppBridgeProvider
          config={{
            host: host,
            apiKey: process.env.NEXT_PUBLIC_SHOPIFY_API_KEY || "",
            forceRedirect: true,
          }}
        >
          {AppContent}
        </AppBridgeProvider>
      ) : (
        AppContent
      )}
    </>
  );
}